// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Reports from '../components/Reports';

import {actions} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    saveSuccess: state.reports.saveSuccess,
    isSaving: state.reports.isSaving,
    trackingId: state.reports.trackingId,
    error: state.reports.error,
    isFetchingGA: state.reports.isFetchingGA,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(Reports);
